import { tokenDestinationCard } from "./TokenDestinationCard";

export const OpenAiAdsDestinationCard = tokenDestinationCard({
  type: "openai_ads",
  intro:
    "Sends orders, checkouts, add-to-carts and product views to ChatGPT Ads from our server, so a sale that " +
    "started with a ChatGPT ad still counts when the shopper's browser blocks tracking. Both values are in " +
    "OpenAI Ads Manager under Tools, then Conversions. After you save, create a conversion event for " +
    "order_created in that same place, or purchases will not show in reporting and will not drive bidding. " +
    "If you also run OpenAI's own pixel, set its order_created event ID to the Shopify order ID so each order " +
    "counts once, and turn off any other app sending ChatGPT Ads conversions.",
  fields: [
    {
      key: "pixelId",
      label: "Pixel ID",
      // NO placeholder. "t2_abc123" was copied in from the Reddit card, and
      // it invents a format: OpenAI publishes no pattern, length or example
      // for a pixel id, so showing merchants a shape would send anyone whose
      // id looks different hunting for the wrong value.
      helpText: "Conversions, then the Data Source tab. Paste it exactly as OpenAI shows it.",
    },
    {
      key: "apiKey",
      label: "Conversions API key",
      secret: true,
      helpText:
        "Conversions, then the Conversion Key button, then Create new key. OpenAI shows it once. Your OpenAI " +
        "platform key and your Ads API key will not work here.",
    },
  ],
  testNote:
    "Send test event asks OpenAI to check the key, the pixel and the event format without recording anything, " +
    "because ChatGPT Ads has no test events view. So a passing test will not appear in your reporting. Real " +
    "orders show up there once they start flowing. OpenAI also refuses an event timestamped more than ten " +
    "minutes in the future, so a server with a badly wrong clock sees refusals rather than silent drops.",
});
